import editPlanConsentTemplate from "./EditPlanConsentTemplate";
import EDeliveryEditController from "./EDeliveryEditController";

var EDeliveryDisplayController = function ($scope, $rootScope, $modal, EDeliveryFactory) {
    var vm = this;

    vm.model = null;
    vm.isDataLoaded = false;
    vm.planName = "";
    vm.docTypes = "";
    vm.isDataLoaded = false;

    $scope.submitted = false;
    vm.email = {};

    $rootScope.$on("eConsentUpdated", function (event, data) {
        vm.allowedToOverwrite = EDeliveryFactory.getAllowedToOverwrite();
        vm.eDeliveryOption = EDeliveryFactory.getEDeliveryOption();
        vm.docTypes = EDeliveryFactory.getDocTypes();
        vm.planName = EDeliveryFactory.getPlanName();
        vm.econsentemailAddress = EDeliveryFactory.getEConsentemailAddress();
    });

    $scope.init = function () {
        retrieveParticipantConsentData(EDeliveryFactory.getGaId());
    };

    $scope.init();

    function retrieveParticipantConsentData(gaId) {
        if (gaId === "" || gaId === undefined) {
            return;
        }

        var retrieveConsentData = {
            gaId: gaId
        };

        EDeliveryFactory.retrieveParticipantConsent.query(
            retrieveConsentData,
            function (data, headers) {
                if (data !== null) {
                    vm.allowedToOverwrite = data.data.allowedToOverwrite;
                    vm.eDeliveryOption = data.data.eDeliveryOption;
                    vm.docTypes = data.data.docTypes;
                    vm.planName = data.data.planName;
                    vm.econsentemailAddress = data.data.econsentemailAddress;

                    EDeliveryFactory.setDocTypes(data.data.docTypes);
                    EDeliveryFactory.setPlanName(data.data.planName);
                    EDeliveryFactory.setPptConsent(data.data.pptConsent);
                    EDeliveryFactory.setEConsentemailAddress(data.data.econsentemailAddress);
                    EDeliveryFactory.setSecondaryEmail(data.data.secondaryEmailAddress);
                }
            },
            function (response) {
                console.error("retrive participant  electronic delivery data  failed");
            }
        );
    }

    /**
     * Open modal
     **/

    $scope.openEConsentModal = function () {
        $modal.open({
            template: editPlanConsentTemplate,
            controller: EDeliveryEditController,
            controllerAs: "vm",
            size: "md",
            windowClass: "modal-wrapper"
        });
    };
};

EDeliveryDisplayController.$inject = ["$scope", "$rootScope", "$modal", "EDeliveryFactory"];
export default EDeliveryDisplayController;
